// eslint-disable-next-line
const apiHost = process.browser ? process.env.apiHostBrowser : process.env.apiHostServer;
// eslint-disable-next-line
const apiPath = process.env.apiPath;
export default {
    NEWSPAPERS_CATALOGS_OCCASIONS_URL: `${apiHost}${apiPath}newspaper/menu`,
};
